import { Spinner } from "@material-tailwind/react";
import CardTable from "../Table/CustomTable"
import { useTranslation } from 'react-i18next'
import { useState, useEffect } from "react";
import { faGraduationCap } from "@fortawesome/free-solid-svg-icons";
import * as Papa from 'papaparse';
import { BASE_NAME } from "../../routes";
import { parseBibTex } from "../../utils";

const MSCProjects = () => {

    const translationPrefix = 'Teaching'
    const { t } = useTranslation('global');
    const [proyectos, setProyectos] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(true);

    const columns = [
        {
            id: 'year',
            label: t(`${translationPrefix}.año`),
        },
        {
            id: 'title',
            label: t(`${translationPrefix}.nombre`),
        },
        {
            id: 'author',
            label: t(`${translationPrefix}.estudiantes`),
        },
        {
            id: 'tutor',
            label: t(`${translationPrefix}.tutores`),
        },
        {
            id: 'url',
            label: t(`${translationPrefix}.ver_mas`),
        }     
    ]

    useEffect(() => {
        fetch(`${BASE_NAME}/data/proyectos_posgrado.csv`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.text();
        })
        .then(data => {
            const parsedData = Papa.parse(data, { header: true,  delimiter: ';' }).data;
            if (parsedData.length){
                setRowCount(parsedData.length);
                let proyectosBib = []
                parsedData.forEach(row => {
                    proyectosBib.push(parseBibTex(row['proyecto']))
                })   
                setProyectos(proyectosBib);
            }
            setLoading(false);
        })
        .catch(error => console.error('Error fetching CSV data:', error));
    }, [])

    return (
        <>
        {
            loading ? 
            <div className="flex flex-col h-screen justify-center items-center h-full">
                <Spinner className="h-12 w-12" />
            </div>
            :
            <section className="py-32">
                <div className="container mx-auto">
                    <div className="items-center justify-center flex">
                        <div className="w-full px-12 mb-12 px-4">
                            <CardTable 
                                icon={faGraduationCap}
                                title={t(`${translationPrefix}.proypos`)}
                                columns={columns} 
                                rows={proyectos}
                                rowCount={rowCount}
                            />
                        </div>
                    </div>
                </div>
            </section>
        }
        </>
    );
}

export default MSCProjects;